<div class="multimedia-i-zalaczniki">
  <div class="multimedia" *ngIf="multimedia && multimedia.pliki.length>0">
    <div class="pojedyncze-mp3" *ngIf="dzwieki?.pliki?.length===1">
      <div *ngFor="let img of dzwieki?.pliki">
        <div *mmAudio="img?.rozszerzenie">
          <mm-audio-player [src]="url+img.sciezka"></mm-audio-player>
        </div>
      </div>
    </div>
    <div class="pojedyncze" *ngIf="obrazkiIWideo?.pliki?.length===1&&show">
      <div *ngFor="let img of obrazkiIWideo?.pliki">
        <img *mmImg="img?.rozszerzenie" [src]="url+img.sciezka" (click)="pokazGaleriePelnoekranowa()" loading="lazy"
          [alt]="img.opisAlt ? img.opisAlt : obiekt?.tytul" oncontextmenu="return false;" draggable="false"/>

        <video *mmVideo="img?.rozszerzenie" [src]="url+img.sciezka" controls></video>
        <div class="tekst-e gray w-full">
          <small>{{img.opis}}</small>
        </div>
      </div>
    </div>

    <div *ngIf="obrazkiIWideo && obrazkiIWideo.pliki!.length>1">
      <div class="wielokrotne" *mmTylkoMobile>
        <div class="karuzela">
          <div class="poprzednie">
            <mm-przycisk-ikona label="{{'codes.modul-mapowy.przegladanie-obiektow.poprzednie-multimedium' | translate}}"
              ikona="poprzedni" typ="'blekitny'" (click)="poprzednieZdjecie()"></mm-przycisk-ikona>
          </div>
          <div *ngFor="let miniaturka of plikiWKaruzeli"
            [style.backgroundImage]="'url('+ miniaturka.plik.sciezkaMiniaturki+')'"
            [class.zaznaczone]="wybraneZdjecieIndeks===miniaturka.index" (click)="ustawZdjecie(miniaturka.index)"></div>
          <div class="nastepne">
            <mm-przycisk-ikona label="{{'codes.modul-mapowy.przegladanie-obiektow.nastepne-multimedium' | translate}}"
              ikona="nastepny" typ="'blekitny'" (click)="nastepneZdjecie()"></mm-przycisk-ikona>
          </div>
        </div>
        <div class="widok">

          <img *mmImg="wybraneZdjecie?.rozszerzenie" [src]="url+wybraneZdjecie?.sciezka"
            [alt]="wybraneZdjecie?.opisAlt ? wybraneZdjecie?.opisAlt : wybraneZdjecie?.opis"
            (swipeleft)="nastepneZdjecie()" (swiperight)="poprzednieZdjecie()" (click)="pokazGaleriePelnoekranowa()"
            loading="lazy" oncontextmenu="return false;" draggable="false"/>
          <video *mmVideo="wybraneZdjecie?.rozszerzenie" src="{{url+wybraneZdjecie?.sciezka}}" controls></video>
          <div class="tekst-e gray w-full">
            <small>{{wybraneZdjecie?.opis}}</small>
          </div>
        </div>

      </div>
      <div class="wielokrotne-desktop" *mmTylkoDesktop>
        <div class="karuzela-desktop">
          <div class="poprzednie-desktop">
            <mm-przycisk-ikona label="{{'codes.modul-mapowy.przegladanie-obiektow.poprzednie-multimedium' | translate}}"
              ikona="zwin2" typ="'blekitny'" (click)="poprzednieZdjecie()"></mm-przycisk-ikona>
          </div>
          <div *ngFor="let miniaturka of plikiWKaruzeli" class="miniaturka-background-color"
            [style.backgroundImage]="'url('+ miniaturka.plik.sciezkaMiniaturki+')'"
            [class.zaznaczone]="wybraneZdjecieIndeks===miniaturka.index" (click)="ustawZdjecie(miniaturka.index)"></div>
          <div class="nastepne-desktop">
            <mm-przycisk-ikona label="{{'codes.modul-mapowy.przegladanie-obiektow.nastepne-multimedium' | translate}}"
              ikona="rozwin2" typ="'blekitny'" (click)="nastepneZdjecie()"></mm-przycisk-ikona>
          </div>
        </div>
        <div class="widok-desktop">
          <img *mmImg="wybraneZdjecie?.rozszerzenie" [src]="url+wybraneZdjecie?.sciezka" (swipeleft)="nastepneZdjecie()"
            (swiperight)="poprzednieZdjecie()" (click)="pokazGaleriePelnoekranowa()" loading="lazy"
            draggable="false"
            [alt]="wybraneZdjecie?.opisAlt ? wybraneZdjecie?.opisAlt : obiekt?.tytul" oncontextmenu="return false;" />
          <video *mmVideo="wybraneZdjecie?.rozszerzenie" src="{{url+wybraneZdjecie?.sciezka}}" controls></video>

          <div *mmAudio="wybraneZdjecie?.rozszerzenie">
            <mm-audio-player [src]="url+wybraneZdjecie?.sciezka"></mm-audio-player>
          </div>
          <div class="tekst-e gray w-full text-center">
            <small>{{wybraneZdjecie?.opis}}</small>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="dzwieki && dzwieki.pliki!.length>1">
      <div class="wielokrotne" *mmTylkoMobile>
        <div class="karuzela">
          <div class="poprzednie">
            <mm-przycisk-ikona label="{{'codes.modul-mapowy.przegladanie-obiektow.poprzednie-multimedium' | translate}}"
              ikona="poprzedni" typ="'blekitny'" (click)="poprzednieAudio()"></mm-przycisk-ikona>
          </div>
          <div *ngFor="let miniaturka of plikiWKaruzeliAudio"
            [style.backgroundImage]="'url('+ miniaturka.plik.sciezkaMiniaturki+')'"
            [class.zaznaczone]="wybraneAudioIndeks===miniaturka.index" (click)="ustawAudio(miniaturka.index)"></div>
          <div class="nastepne">
            <mm-przycisk-ikona label="{{'codes.modul-mapowy.przegladanie-obiektow.nastepne-multimedium' | translate}}"
              ikona="nastepny" typ="'blekitny'" (click)="nastepneAudio()"></mm-przycisk-ikona>
          </div>
        </div>
        <div class="widok">
          <div *mmAudio="wybraneAudio?.rozszerzenie">
            <mm-audio-player [src]="url+wybraneAudio?.sciezka"></mm-audio-player>
          </div>
        </div>
      </div>
      <div class="wielokrotne-desktop" *mmTylkoDesktop>
        <div class="karuzela-desktop">
          <div class="poprzednie-desktop">
            <mm-przycisk-ikona label="{{'codes.modul-mapowy.przegladanie-obiektow.poprzednie-multimedium' | translate}}"
              ikona="zwin2" typ="'blekitny'" (click)="poprzednieAudio()"></mm-przycisk-ikona>
          </div>
          <div *ngFor="let miniaturka of plikiWKaruzeliAudio" class="miniaturka-background-color"
            [style.backgroundImage]="'url('+ miniaturka.plik.sciezkaMiniaturki+')'"
            [matTooltip]="miniaturka.plik.nazwaPliku" [class.zaznaczone]="wybraneAudioIndeks===miniaturka.index"
            (click)="ustawAudio(miniaturka.index)"></div>
          <div class="nastepne-desktop">
            <mm-przycisk-ikona label="{{'codes.modul-mapowy.przegladanie-obiektow.nastepne-multimedium' | translate}}"
              ikona="rozwin2" typ="'blekitny'" (click)="nastepneAudio()"></mm-przycisk-ikona>
          </div>
        </div>
        <div class="widok-desktop">
          <img *mmImg="wybraneAudio?.rozszerzenie" [src]="url+wybraneAudio?.sciezka" (swipeleft)="nastepneAudio()"
            (swiperight)="poprzednieAudio()" (click)="pokazGaleriePelnoekranowa()" loading="lazy" draggable="false"
            [alt]="obiekt?.tytul" />
            <div *mmAudio="wybraneAudio?.rozszerzenie" >
            <mm-audio-player [src]="url+wybraneAudio?.sciezka"></mm-audio-player>
            </div>
        </div>
      </div>
    </div>

    <div class="zalaczniki" *ngIf="zalaczniki && zalaczniki.pliki.length>0">
      <div class="lista" *ngIf="zalaczniki?.pliki && zalaczniki?.pliki!.length>0">
        <a class="naglowek-d" target="_blank" [href]="url+zalacznik.sciezka" *ngFor="let zalacznik of zalaczniki?.pliki"
          download>{{zalacznik.nazwaPliku}}</a>
      </div>
    </div>
    <div class="galeria-pelen-ekran" *ngIf="widocznaGaleriaPelnoekranowa && wybraneZdjecie"
      (swipeleft)="nastepneZdjecie()" (swiperight)="poprzednieZdjecie()">
      <mm-przycisk-ikona *ngIf="plikiWKaruzeli && plikiWKaruzeli.length>1" [label]="'Poprzednie zdjęcie'"
        class="sterowanie-galeria-full-left" ikona="poprzedni" typ="'blekitny'"
        (onClick)="poprzednieZdjecie()"></mm-przycisk-ikona>
      <img [src]="url+wybraneZdjecie.sciezka" loading="lazy" oncontextmenu="return false;" draggable="false"
        [alt]="wybraneZdjecie.opisAlt ? wybraneZdjecie.opisAlt : wybraneZdjecie.opis" />
      <div class="tekst-e w-full text-center absolute bottom-5 p-1 text-white background-pelny-ekran text-xl">
        <small>{{wybraneZdjecie.opis}}</small>
      </div>
      <mm-przycisk-ikona *ngIf="plikiWKaruzeli && plikiWKaruzeli.length>1" [label]="'Następne zdjęcie'"
        class="sterowanie-galeria-full-right" ikona="nastepny" typ="'blekitny'"
        (onClick)="nastepneZdjecie()"></mm-przycisk-ikona>
      <div class="zamknij">
        <mm-przycisk-ikona label="{{'codes.generyczne.zamknij' | translate}}" typ="przezroczysty" ikona="zamknij"
          (click)="zamknijGaleriePelnoekranowa()"></mm-przycisk-ikona>
      </div>
    </div>
  </div>
</div>
